import moment from 'moment';
import { flatMap, isPlainObject } from 'lodash';
import { ToastProgrammatic as Toast } from 'buefy';
import i18n from '@/i18n/index';
import calculArrondi from '../calcul/calculArrondi';

moment.locale('fr');

export function formatDate(date) {
  if (date === null || date === undefined) {
    return '';
  }
  return moment(date).format('L');
}

export function formatNombre(nombre) {
  const val = nombre ? nombre : 0;
  return new Intl.NumberFormat('fr', { style: 'currency', currency: 'EUR' }).format(val);
}

export function getImg(img) {
  if (img) return img;
  return require('@/assets/images/general/default_img.png');
}

export function getImgPictoFile(type) {
  const tabType = ['ai', 'avi', 'css', 'doc', 'eps', 'gif', 'html', 'jpg',
    'mov', 'mp3', 'pdf', 'png', 'ppt', 'psd', 'rar', 'svg', 'txt', 'wav', 'xd', 'xlm', 'xlsx', 'zip'];
    if (tabType.includes(type.toLowerCase())) {
      return require('../../assets/images/icon_png/' + type.toLowerCase() + '.png');
    } else {
     return require('../../assets/images/icon_png/autre.png');
    }
}

export function gestionDev() {
  Toast.open({
    duration: 2000,
    message: i18n.t('general.inDev'),
    position: 'is-top',
    type: 'is-primary',
  });
}

export function getImgIconAzimut(azimut) {
  return require('../../assets/images/icons_azimut/' + azimut + '.png')
}

export function bytesToSize(bytes) {
  const sizes = ['b', 'Kb', 'Mb', 'Gb', 'Tb'];
  if (bytes == 0) return '0 b';
  const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
  return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
}

export function dataURItoFile(dataURI) {
  if (dataURI == "") return null;
  const BASE64_MARKER = ';base64,';
  const mime = dataURI.split(BASE64_MARKER)[0].split(':')[1];
  const filename = 'image-' + (new Date()).getTime() + '.' + mime.split('/')[1];
  const bytes = atob(dataURI.split(BASE64_MARKER)[1]);
  let writer = new Uint8Array(new ArrayBuffer(bytes.length));

  for (var i=0; i < bytes.length; i++) {
    writer[i] = bytes.charCodeAt(i);
  }

  return new File([writer.buffer], filename, { type: mime });
}

export function arrondiResult(value) {
  let newValue = value;
  if (newValue) {
    newValue = Math.round(newValue * 100) / 100;
  }
  return newValue;
}

export function verifierAnnuiteBlocAnnuel(data) {
  const nbreYear = calculArrondi(moment(data.dateFin).diff(moment(data.dateDebut), 'years', true));
  if (Number.isInteger(nbreYear)) return true; else return false;
}

export function addressStringBase(address) {
  if (!address) return '';
  const addressBase1 = [
    address.adresse1,
    address.adresse2,
    address.adresse3,
  ].filter(Boolean).join(' ');
  return addressBase1;
}

export function adressFullStringGetter(adresse) {
  if (!adresse) return '';
  const adresseBase2 = [
    adresse.codePostal,
    adresse.ville,
  ].filter(Boolean).join(' ');
  return [addressStringBase(adresse), adresseBase2].filter(Boolean).join(', ');
}

export function getPropertyPaths(obj, prefix = '') {
  return flatMap(obj, (value, key) => {
    const path = prefix ? `${prefix}.${key}` : key;
    return isPlainObject(value) ? getPropertyPaths(value, path) : path;
  });
}
